import { render, staticRenderFns } from "./island-soil.vue?vue&type=template&id=37158cca&"
import script from "./island-soil.vue?vue&type=script&lang=js&"
export * from "./island-soil.vue?vue&type=script&lang=js&"
import style0 from "./island-soil.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports